<template>
  <artmisads-modal
    v-model:open="visible"
    :title="title"
    :width="currentStep === 0 || currentStep === 1 ? 1200 : 800"
    :footer="null"
    @cancel="handleClose"
  >
    <div
      class="partnership-modal-content"
      v-if="currentStep === 0 || currentStep === 1 || currentStep === 2"
    >
      <div class="multiple-top">
        <a-steps :current="currentStep" :items="stepItem"></a-steps>
      </div>
      <setPartnershipSecond
        ref="partnershipSecondRef"
        @refresh="refresh"
        @back="handleBack"
        :publisherChecked="publisherChecked"
        :brandChecked="brandChecked"
        v-if="currentStep === 2"
      />
      <template v-else>
        <div class="bottom">
          <a-spin :spinning="loading">
            <div
              class="left"
              ref="leftScrollRefPublisher"
              @scroll="handleScroll"
              v-if="currentStep === 0"
            >
              <div class="left-top">
                <a-input v-model:value="value5" @enter="handleSearch">
                  <template #addonAfter>
                    <Icon
                      name="sousuo"
                      @click="handleSearch"
                      class="icon-svg"
                    />
                  </template>
                </a-input>
              </div>
              <div class="bottom-select">
                <div v-for="value in pulisherData">
                  <div class="item" v-if="!value.currentCommissionDetail">
                    <a-checkbox
                      v-model:checked="value.checked"
                      @change="changeItem"
                    >
                      <div class="item-left-box">
                        <div class="item-left">
                          <LogoImage
                            :maxWidth="'95%'"
                            :logoUrl="value?.publicImage"
                            :brandName="value?.creatorName"
                            :width="48"
                            :height="48"
                            :lineHeight="14"
                            :fontSize="10"
                          />
                        </div>

                        <div class="item-right">
                          <div class="item-text">
                            {{ value?.creatorName
                            }}{{
                              value?.hasDuplicate
                                ? `(${value?.amazonProfileAccountInfoName})`
                                : ''
                            }}
                          </div>
                          <div
                            class="item-bottom"
                            v-if="value.currentCommissionDetail"
                          >
                            <div class="item-bottom-left">
                              {{
                                value.currentCommissionDetail?.commissionRate
                              }}%
                            </div>
                            <div class="item-bottom-right">
                              End Date
                              {{ value.currentCommissionDetail?.endDateStr }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a-checkbox>
                  </div>
                  <a-popover
                    :mouseLeaveDelay="1"
                    placement="right"
                    arrow-point-at-center
                    v-if="value.currentCommissionDetail"
                  >
                    <template #content>
                      <div class="text">
                        The commission rates for media partners and their
                        cooperation expiration dates can be viewed here.
                      </div>
                      <div class="item-bottom bottom-select-bottom">
                        <div class="item-bottom-left">
                          {{ value.currentCommissionDetail?.commissionRate }}%
                        </div>
                        <div class="item-bottom-right">
                          End Date
                          {{ value.currentCommissionDetail?.endDateStr }}
                        </div>
                      </div>
                    </template>
                  </a-popover>
                </div>
                <!-- <a-popover
                :mouseLeaveDelay="1"
                placement="right"
                arrow-point-at-center
                v-for="value in pulisherData"
              >
                <template #content>
                  <div class="text">
                    The commission rates for media partners and their
                    cooperation expiration dates can be viewed here.
                  </div>
                  <div class="item-bottom bottom-select-bottom">
                    <div class="item-bottom-left">24.5%</div>
                    <div class="item-bottom-right">End Date 2025-11-30</div>
                  </div>
                </template>
                <div class="item">
                  <a-checkbox
                    v-model:checked="value.checked"
                    @change="changeItem"
                  >
                    <div class="item-left-box">
                      <div class="item-left">
                        <LogoImage
                          :maxWidth="'95%'"
                          :logoUrl="value?.publicImage"
                          :brandName="value?.creatorName"
                          :width="48"
                          :height="48"
                          :lineHeight="14"
                          :fontSize="10"
                        />
                      </div>

                      <div class="item-right">
                        <div class="item-text">
                          {{ value?.creatorName
                          }}{{
                            value?.hasDuplicate
                              ? `(${value?.amazonProfileAccountInfoName})`
                              : ''
                          }}
                        </div>
                        <div class="item-bottom">
                          <div class="item-bottom-left">24.5%</div>
                          <div class="item-bottom-right">
                            End Date 2025-11-30
                          </div>
                        </div>
                      </div>
                    </div>
                  </a-checkbox>
                </div>
              </a-popover> -->
              </div>
            </div>
            <div
              class="left"
              ref="leftScrollRefBrand"
              @scroll="handleScroll"
              v-if="currentStep === 1"
            >
              <div class="left-top">
                <a-input v-model:value="value5" @enter="handleSearch">
                  <template #addonAfter>
                    <Icon
                      name="sousuo"
                      @click="handleSearch"
                      class="icon-svg"
                    />
                  </template>
                </a-input>
              </div>
              <div class="bottom-select">
                <div v-for="value in bandData">
                  <div class="item" v-if="!value.currentCommissionDetail">
                    <a-checkbox
                      v-model:checked="value.checked"
                      @change="changeItem"
                    >
                      <div class="item-left-box">
                        <div class="item-left">
                          <LogoImage
                            :maxWidth="'95%'"
                            :logoUrl="value?.publicImage"
                            :brandName="value?.creatorName"
                            :width="48"
                            :height="48"
                            :lineHeight="14"
                            :fontSize="10"
                          />
                        </div>

                        <div class="item-right">
                          <div class="item-text">
                            {{ value?.creatorName
                            }}{{
                              value?.hasDuplicate
                                ? `(${value?.amazonProfileAccountInfoName})`
                                : ''
                            }}
                          </div>
                          <div
                            class="item-bottom"
                            v-if="value.currentCommissionDetail"
                          >
                            <div class="item-bottom-left">
                              {{
                                value.currentCommissionDetail?.commissionRate
                              }}%
                            </div>
                            <div class="item-bottom-right">
                              End Date
                              {{ value.currentCommissionDetail?.endDateStr }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </a-checkbox>
                  </div>
                  <a-popover
                    :mouseLeaveDelay="1"
                    placement="right"
                    arrow-point-at-center
                    v-if="value.currentCommissionDetail"
                  >
                    <template #content>
                      <div class="text">
                        The commission rates for media partners and their
                        cooperation expiration dates can be viewed here.
                      </div>
                      <div class="item-bottom bottom-select-bottom">
                        <div class="item-bottom-left">
                          {{ value.currentCommissionDetail?.commissionRate }}%
                        </div>
                        <div class="item-bottom-right">
                          End Date
                          {{ value.currentCommissionDetail?.endDateStr }}
                        </div>
                      </div>
                    </template>
                  </a-popover>
                </div>
              </div>
            </div>
          </a-spin>
          <div class="right">
            <div class="right-title" v-if="currentStep === 0">
              <span class="selected-count">{{
                currentStep === 0 ? 'Selected Publisher' : 'Selected Brands'
              }}</span>
              (<span class="selected-count">{{ currentTags.length }}</span
              ><span class="total-count">/100</span>)
            </div>
            <div class="right-content">
              <div v-if="currentStep === 0">
             
              <div class="tags-container" >
                <div v-for="tag in publisherChecked" :key="tag.id" class="tag-item" >
                  <LogoImage
                    :maxWidth="'95%'"
                    :logoUrl="tag?.publicImage"
                    :brandName="tag?.creatorName"
                    :width="20"
                    :height="20"
                    :lineHeight="6"
                    :fontSize="5"
                    :borderRadius="4"
                  />
                  <span
                    >{{ tag.creatorName }}
                    {{
                      tag.hasDuplicate
                        ? `(${tag.amazonProfileAccountInfoName})`
                        : ''
                    }}
                  </span>
                  <Icon
                    @click.stop="removeTag(tag)"
                    name="a-error-tianchong5"
                    class="icon-svg"
                  />
                </div>
              </div>
              </div>
              <div  v-if="currentStep === 1">
             <div class="right-title" >
              <span class="selected-count">
               Selected Publisher
              </span>
              (<span class="selected-count">{{ publisherChecked.length }}</span
              ><span class="total-count">/100</span>)
            </div>
              <div class="tags-container" >
                <div v-for="tag in publisherChecked" :key="tag.id" class="tag-item" >
                  <LogoImage
                    :maxWidth="'95%'"
                    :logoUrl="tag?.publicImage"
                    :brandName="tag?.creatorName"
                    :width="20"
                    :height="20"
                    :lineHeight="6"
                    :fontSize="5"
                    :borderRadius="4"
                  />
                  <span
                    >{{ tag.creatorName }}
                    {{
                      tag.hasDuplicate
                        ? `(${tag.amazonProfileAccountInfoName})`
                        : ''
                    }}
                  </span>
                
                </div>
              </div>

              <div class="right-title" style="margin-top: 40px;">
              <span class="selected-count">
               Selected Brand
              </span>
              (<span class="selected-count">{{ brandChecked.length }}</span
              ><span class="total-count">/100</span>)
            </div>
              <div class="tags-container" >
             <div v-for="tag in brandChecked" :key="tag.id" class="tag-item" >
                  <LogoImage
                    :maxWidth="'95%'"
                    :logoUrl="tag?.publicImage"
                    :brandName="tag?.creatorName"
                    :width="20"
                    :height="20"
                    :lineHeight="6"
                    :fontSize="5"
                    :borderRadius="4"
                  />
                  <span
                    >{{ tag.creatorName }}
                    {{
                      tag.hasDuplicate
                        ? `(${tag.amazonProfileAccountInfoName})`
                        : ''
                    }}
                  </span>
                  <Icon
                    @click.stop="removeTag(tag)"
                    name="a-error-tianchong5"
                    class="icon-svg"
                  />
                </div>
              </div>
              </div>
              <!-- <div class="tags-container" v-if="currentStep === 1">
                <div v-for="tag in publisherChecked" :key="tag.id" class="tag-item" >
                  <LogoImage
                    :maxWidth="'95%'"
                    :logoUrl="tag?.publicImage"
                    :brandName="tag?.creatorName"
                    :width="20"
                    :height="20"
                    :lineHeight="6"
                    :fontSize="5"
                    :borderRadius="4"
                  />
                  <span
                    >{{ tag.creatorName }}
                    {{
                      tag.hasDuplicate
                        ? `(${tag.amazonProfileAccountInfoName})`
                        : ''
                    }}
                  </span>
                  <Icon
                    @click.stop="removeTag(tag)"
                    name="a-error-tianchong5"
                    class="icon-svg"
                  />
                </div>
                <div v-for="tag in brandChecked" :key="tag.id" class="tag-item" >
                  <LogoImage
                    :maxWidth="'95%'"
                    :logoUrl="tag?.publicImage"
                    :brandName="tag?.creatorName"
                    :width="20"
                    :height="20"
                    :lineHeight="6"
                    :fontSize="5"
                    :borderRadius="4"
                  />
                  <span
                    >{{ tag.creatorName }}
                    {{
                      tag.hasDuplicate
                        ? `(${tag.amazonProfileAccountInfoName})`
                        : ''
                    }}
                  </span>
                  <Icon
                    @click.stop="removeTag(tag)"
                    name="a-error-tianchong5"
                    class="icon-svg"
                  />
                </div>
              </div> -->
            </div>
          </div>
        </div>
        <div class="bottom-btn">
          <artmisads-button
            @click="handleBackBottom"
            :loading="saving"
            v-if="currentStep === 1"
          >
            Back
          </artmisads-button>
          <artmisads-button
            type="primary"
            @click="handleSave"
            :loading="saving"
            :disabled="currentStep ===0?publisherChecked.length === 0 :brandChecked.length === 0"
          >
            Next
          </artmisads-button>
        </div>
      </template>
    </div>
  </artmisads-modal>
</template>
<script setup>
import {
  ref,
  defineExpose,
  onMounted,
  onUnmounted,
  nextTick,
  computed,
} from 'vue'
import LogoImage from '@/components/LogoImage.vue'
import Icon from '@/components/Icon.vue'
import setPartnershipSecond from './setPartnershipSecond.vue'
import { publishersApi, brandApi } from '@/server'
import { message, notification } from 'ant-design-vue'
import { countBrandNames } from '~/utils'
const visible = ref(false)

const partnershipSecondRef = ref(null)
const title = ref('Bulk Create Partnerships')
const currentStep = ref(0)
const value5 = ref('')
const handleSearch = async () => {
  if (currentStep.value === 0) {
      paramsPubisher.value.page=1
    await getPublishersList()
  }
  if (currentStep.value === 1) {
  paramsBand.value.page=1
    await getBrandsList()
  }
   nextTick(() => {
    if (leftScrollRefBrand.value) {
      leftScrollRefBrand.value.scrollTop = 0
    }
    if (leftScrollRefPublisher.value) {
      leftScrollRefPublisher.value.scrollTop = 0
    }
  })
}
const stepItem = ref([
  {
    title: 'Select publisher',
  },
  {
    title: 'Select brand',
  },
  {
    title: 'Set Commission',
  },
])
const brandId = ref('')
const type = ref('')

const loading = ref(false)
const paramsPubisher = ref({
  page: 1,
  pageSize: 10,
  total: 0,
})
const paramsBand = ref({
  page: 1,
  pageSize: 10,
  total: 0,
})
const data = ref([])
const pulisherData = ref([])
const bandData = ref([])
// const currentTags = ref([])
const leftScrollRefPublisher = ref(null)
const leftScrollRefBrand = ref(null)
const isLoadingMore = ref(false)
const handleClose = () => {
  closeModal()
}
const publisherChecked = computed(() => {
  return pulisherData.value.filter((tag) => tag.checked)
})
const brandChecked = computed(() => {
  return bandData.value.filter((tag) => tag.checked)
})
const currentTags = computed(() => {
  if (currentStep.value === 0) {
    return pulisherData.value.filter((tag) => tag.checked)
  } else if (currentStep.value === 1) {
    return bandData.value.filter((tag) => tag.checked)
  }
})
const changeItem = (item) => {
  if(currentStep.value === 0){
    if(pulisherData.value.length>=100){
  message.error('You can only select up to 100 items')
    }
  } 
  if(currentStep.value === 1){
     if(bandData.value.length>=100){
  message.error('You can only select up to 100 items')
    }
  }
  item.checked = !item.checked
  
}
const closeModal = () => {
  visible.value = false
}
const show = () => {
  currentTags.value = []
  visible.value = true
  currentStep.value = 0
  paramsPubisher.value.page=1
  paramsBand.value.page=1
  // 滚动条滚动到最上面
  nextTick(() => {
    if (leftScrollRefBrand.value) {
      leftScrollRefBrand.value.scrollTop = 0
    }
    if (leftScrollRefPublisher.value) {
      leftScrollRefPublisher.value.scrollTop = 0
    }
  })
  getPublishersList()
  getBrandsList()
  // if(type.value==='publisher'){
  //   getPublishersList()
  // }
  // if(type.value==='brands'){
  //   getBrandsList()
  // }
}

const removeTag = (tag) => {

  if (currentStep.value === 0) {
    pulisherData.value.forEach((item) => {
      if (item.id === tag.id) {
        item.checked = false
      }
    })
  }
  if (currentStep.value === 1) {
    bandData.value.forEach((item) => {
      if (item.id === tag.id) {
        item.checked = false
      }
    })
  }
}
const handleBackBottom = async () => {
  currentStep.value--
  // getPublishersList()
}
const handleSave = async () => {
  await nextTick()
  value5.value = ''
  currentStep.value++
  if (currentStep.value === 1) {
  

    
   
  
    
 
    
  }
  if (currentStep.value === 2) {
   // 创建publisher和brand的一对多关系数据结构
  let list = []
    
    // 遍历每个选中的publisher
    publisherChecked.value.forEach((publisher) => {
      // 为每个publisher创建与所有选中brand的关联
      brandChecked.value.forEach((brand) => {
        list.push({
          // 确保使用正确的属性名
          id: publisher.id,
          brandId: brand.brandId,
          
        })
      })
    })
     await nextTick()

    partnershipSecondRef.value?.showModal(list, 'multiple',list)
  }
}

const handleScroll = (event) => {
  const params =
    currentStep.value === 0 ? paramsPubisher.value : paramsBand.value
  const { scrollTop, scrollHeight, clientHeight } = event.target
  // 当滚动到底部时（留有一点余量）
  if (scrollTop + clientHeight >= scrollHeight - 10 && !isLoadingMore.value) {
    // 检查是否还有更多数据可加载
    if (params.page * params.pageSize < params.total) {
      loadMoreData()
    }
  }
}

const loadMoreData = async () => {
  if (isLoadingMore.value) return

  isLoadingMore.value = true
  if (currentStep.value === 0) {
    paramsPubisher.value.page += 1
  }
  if (currentStep.value === 1) {
    paramsBand.value.page += 1
  }

  try {
    let res
    if (currentStep.value === 0) {
      res = await publishersApi.getPublishers({
        page: paramsPubisher.value.page,
        size: paramsPubisher.value.pageSize,
      })
    }
    if (currentStep.value === 1) {
      res = await publishersApi.getPartSellerBrands({
        page: paramsBand.value.page,
        size: paramsBand.value.pageSize,
      })
    }
    if (res.success) {
      let newData
      if (currentStep.value === 0) {
        newData = res.data?.data?.map((item) => ({
          ...item.publisherVO,
          associateBrandCount: item.associateBrandCount,
          currentCommissionDetail: item.currentCommissionDetail,
          checked: false,
        }))
      }
      if (currentStep.value === 1) {
              const brandNameCount = countBrandNames(
        res.data?.data,
        'brandVO.amazonBrandName'
      )
        newData = res.data?.data?.map((item) => ({
          creatorName: item.amazonBrandName || '',
          publicImage: item.logoImageUrl || '',
          nextMonthCommissionDetail: item.nextMonthCommissionDetail,
          status: item.status,
          startDateStr: item.startDateStr,
          endDateStr: item.endDateStr,
          publisherId: item.publisherId,
          brandId: item.brandId,
          commissionRate: item?.currentCommissionDetail?.commissionRate,
          lastCommissionRate: item?.lastCommissionRate,
          hasDuplicate:
            item.amazonBrandName && brandNameCount[item.amazonBrandName] > 1,
        }))
      }
      // 过滤有效的链接
      newData?.forEach((item) => {
        if (item?.links) {
          item.links = item?.links?.filter((link) => link.url)
        }
      })

      // 将新数据添加到现有数据中
      if (currentStep.value === 0) {
        pulisherData.value = [...pulisherData.value, ...newData]
        paramsPubisher.value.total = res.data.total
      }
      if (currentStep.value === 1) {
        bandData.value = [...bandData.value, ...newData]
        paramsBand.value.total = res.data.total
      }
    }
  } catch (error) {
   
    message.error('Failed to load more data')
    // 加载失败时回滚页码
    if (currentStep.value === 0) {
      paramsPubisher.value.page -= 1
    }
    if (currentStep.value === 1) {
      paramsBand.value.page -= 1
    }
  } finally {
    isLoadingMore.value = false
  }
}
const getPublishersList = async () => {
  loading.value = true

  try {
    const res = await publishersApi.getPublishers({
      page: paramsPubisher.value.page,
      size: paramsPubisher.value.pageSize,
      keyword: value5.value,
      associateEnable: 1,
    })
    if (res.success) {
      pulisherData.value = res.data?.data?.map((item) => ({
        ...item.publisherVO,
        associateBrandCount: item.associateBrandCount,
        currentCommissionDetail: item.currentCommissionDetail,
        checked: false,
      }))
      pulisherData.value?.forEach((item) => {
        if (item?.links) {
          item.links = item?.links?.filter((link) => {
            return link.url
          })
        }
      })

      paramsPubisher.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {
    message.error('Failed to get data')
  } finally {
    loading.value = false
  }
}
const getBrandsList = async () => {
  loading.value = true
  try {
    const res = await brandApi.getAssociateBrandList({
      page: paramsBand.value.page,
      size: paramsBand.value.pageSize,
      keyword: value5.value,
    })
    if (res.success) {
      const brandNameCount = countBrandNames(
        res.data?.data,
        'brandVO.amazonBrandName'
      )
      bandData.value = res.data?.data?.map((item) => {
        return {
          creatorName: item.amazonBrandName || '',
          publicImage: item.logoImageUrl || '',
          nextMonthCommissionDetail: item.nextMonthCommissionDetail,
          status: item.status,
          startDateStr: item.startDateStr,
          endDateStr: item.endDateStr,
          publisherId: item.publisherId,
          brandId: item.id,
          commissionRate: item?.currentCommissionDetail?.commissionRate,
          lastCommissionRate: item?.lastCommissionRate,
          hasDuplicate:
            item.amazonBrandName && brandNameCount[item.amazonBrandName] > 1,
        }
      })

      paramsBand.value.total = res.data.total
    } else {
      message.error(res.error)
    }
  } catch (error) {

    message.error('Failed to get data')
  } finally {
    loading.value = false
  }
}
const refresh = () => {
   nextTick(() => {
    if (leftScrollRefBrand.value) {
      leftScrollRefBrand.value.scrollTop = 0
    }
    if (leftScrollRefPublisher.value) {
      leftScrollRefPublisher.value.scrollTop = 0
    }
  })
 
    pulisherData.value = []
    paramsPubisher.value = {
      page: 1,
      pageSize: 10,
      total: 0,
    }

    bandData.value = []
    paramsBand.value = {
      page: 1,
      pageSize: 10,
      total: 0,
    }

  // if(type.value==='publisher'){
  //   getPublishersList()
  // }
  // if(type.value==='brands'){
  //   getBrandsList()
  // }
  currentTags.value = []
  currentStep.value = 1
  visible.value = false
  emit('refresh')
}
const handleBack = () => {
  currentStep.value = 1
}
defineExpose({
  show,
})
</script>
<style lang="less" scoped>
.bottom-btn {
  display: flex;
  justify-content: flex-end;
  height: 72px;
  align-items: center;
  gap: 12px;
}
.ant-modal-body {
  padding-bottom: 0px !important;
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.bottom-select-bottom {
  margin-top: 10px;
}

.item:hover {
  background-color: #f5f3f9;
}
.ant-popover {
  .ant-popover-arrow-content:before {
    background-color: #262626;
  }
  .ant-popover-inner {
    border-radius: 8px;
    background: #262626;
    padding: 20px;
    .text {
      font-family: 'Sora';
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 15px;
      letter-spacing: 0.3px;
      color: #fff;
    }
  }
}
:deep(.ant-popover-inner) {
  border-radius: 8px;
  background: #262626;
  color: #ffffff;
}
.item-bottom {
  display: flex;
  height: 20px;
  width: 186px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #835cf266;
  background-color: #fff;
  .item-bottom-left {
    width: 37px;
    text-align: center;
    display: inline-flex;
    height: 20px;
    line-height: 20px;
    justify-content: center;
    align-items: center;
    background: #8a64f4;
    color: #ffffff;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Sora';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
  }
  .item-bottom-right {
    text-align: center;
   flex: 1;
    height: 20px;
    line-height: 20px;
    align-items: center;
    color: #694ac2;
    font-feature-settings: 'liga' off, 'clig' off;
    font-family: 'Sora';
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    background: rgba(131, 92, 242, 0.1);
  }
}
.multiple-top {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
}
.bottom {
  display: flex;
  align-items: flex-start;

  align-self: stretch;
  border-radius: 8px;
  border: 1px solid var(--Border-, #e8e5ed);
  .input-search {
    width: 284px;
    height: 32px;

    border-radius: 8px;
  }
  .bottom {
    height: 548px;
  }
  .left {
    height: 548px;
    overflow-y: auto;
    padding: 16px;
    border-right: 1px solid var(--Border-, #e8e5ed);
    .left-top {
    }

    .bottom-select {
      .item {
        padding: 6px 8px;
        margin: 8px 0;
        display: flex;
        align-items: center;
        gap: 12px;
        border-radius: 8px;
        .item-left-box {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        .item-left {
          overflow: hidden;
          border-radius: 8px;
          border: 1px solid var(--Border-, #e8e5ed);
        }
        .item-right {
          display: flex;
          flex-direction: column;
          justify-content: center;
          .item-text {
            color: #0f0629;
            font-family: 'Sora';
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            padding-bottom: 4px;
          }
        }
      }
    }
  }
  .right {
    padding: 20px;
    flex: 1;
    height: 548px;
    display: flex;
    flex-direction: column;
    .right-title {
      .selected-count {
        color: rgb(0, 0, 0);
        font-family: 'Sora';
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
      }
      .total-count {
        color: rgba(15, 6, 41, 0.5);
        font-family: 'PingFang SC';
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
      }
    }
    .right-content {
      margin-top: 10px;
      flex: 1;
      .empty-content {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .tags-container {
        // min-height: 60px;
        // padding: 12px;
        // border: 1px dashed #d9d9d9;
        // border-radius: 6px;
        // background: #50408014;

        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-top: 10px;
        .tag-item {
          display: flex;
          padding: 3px 4px;
          align-items: center;
          gap: 6px;
          border-radius: 6px;
          background: #f1f0f5;
          // margin: 4px 8px 4px 0;
          // padding: 4px 8px;

          font-size: 13px;

          font-weight: 400;
          line-height: 15px;
          letter-spacing: 0.3px;
          .icon-svg {
            color: rgba(15, 6, 41, 0.3);
            cursor: pointer;
          }
          span {
            font-family: 'Sora';
            opacity: 0.7;
            color: #0f0629;
          }
        }
      }
    }
  }
}
</style>
